import { BrowserModule } from '@angular/platform-browser';
import { NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AppComponent } from './app.component';
import { ExpandableListModule } from 'angular2-expandable-list'
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { ChangeDetectorRef } from '@angular/core';
import { DialogComponent } from './dialog/dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { ImageResizerListComponent } from './image-resizer-list/image-resizer-list.component';
import { RestApiServices } from './providers/rest.service';
import { Carousel } from './carousel.component';
import { Slide } from './slide.component';
import { AppRoutingModule } from './app-routing.module';
import { LoginComponent } from './Login/login.component';
import { CustomerDetailsComponent } from './Customerdashboard/customerdetails.component';
import { ConstantService } from "./providers/language.service";
import { CustomerDetailsService } from './Customerdashboard/customerdetails.service';
import {KeysPipe} from './keypipe';
import { CookieService } from 'ngx-cookie-service';
import { Entity, Todo } from './providers/entity';
import { LanguageService } from '../app/providers/lang.service';
import { CustomCookieService } from '../app/providers/mycookie.service';
import { ProductDetailsService } from "./providers/productdetails.service";
import { ProductService } from "./providers/products.service";
import { panelComponent } from './panelitems/panelitems.component';
import { CommonNavbarComponent } from './commonnavbar/commonnavbar.component';
import { ProductDetailsComponent } from './productdetails/productdetails.component';
import { FilterComponent } from './filter/filter.component';
import { FooterComponent } from './footer/footer.component';
import { ShopComponent } from './shop/shop.component';
import { ProductSearchService } from './commonnavbar/productsearch';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AsyncLocalStorageModule } from 'angular-async-local-storage';
import { CustomStorage } from './providers/Custom-storage.service';
import { InvoiceStatusPipe } from "./providers/invoicestatuspipe";
import { InvoiceSearchPipe } from "./providers/invoicesearchpipe";
import { OrderStatusPipe } from "./providers/ordersstatuspipe";
import { ToastService } from './providers/toast';
import { CategoryproductComponent } from './categoryproduct/categoryproduct.component';
import { TopsellerComponent } from './topseller/topseller.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SignaturePadModule } from 'angular2-signaturepad';
import { SearchProductsComponent } from './search-products/search-products.component';
import { SearchlistComponent } from './searchlist/searchlist.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { SoapService } from './checkout/soap.service';
import { SharedServiceService } from './shared/shared-service.service';
import { CustomFilterPipe } from './custom-filter.pipe';
import { Ng2OrderModule } from 'ng2-order-pipe';
import { AuthService } from './auth.service';
import { AuthGuard } from './auth-guard.service';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { NoInternetComponent } from './no-internet/no-internet.component';
import { ProductItemComponent } from './product-item/product-item.component';
//import { FilterCategoryPipe } from './filter-category.pipe';

//import { PagerService } from './_services/pager.service'
import { TreeModule } from 'angular-tree-component';
import { MobileResponsiveComponent } from './mobile-responsive/mobile-responsive.component';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { CartListComponent } from './cart-list/cart-list.component';
import { CartitemsService } from './providers/cartitems.service';
import { LoaderComponent } from './loader/loader.component';
import { OrdersComponent } from './orders/orders.component';
import {ToasterModule, ToasterService} from 'angular2-toaster';
import { OrderlistComponent } from './orderlist/orderlist.component';
//  import { OrderdescriptionComponent } from './orderdescription/orderdescription.component';
import { OrderstatusPipe } from './orderstatus.pipe';
import { NoCommaPipe } from './providers/numberpipe';
import { ViewStateService } from './providers/viewstate';
import { MomentModule } from 'angular2-moment';
import { InvoicelistComponent } from './invoicelist/invoicelist.component';
import { InvoicedescriptionComponent } from './invoicedescription/invoicedescription.component';
import { CollectpaymentComponent } from './collectpayment/collectpayment.component';
import { CartdescriptionComponent } from './cartdescription/cartdescription.component';
import {TooltipModule} from "ngx-tooltip";
import { SupervisorLoginComponent } from './supervisor-login/supervisor-login.component';
// import {GoogleMapsNg2Module} from 'google-maps-ng2';
// import { OnlyNumber } from './providers/keys';
import { AgmCoreModule } from '@agm/core';
import { GoogleMapsAPIWrapper } from '@agm/core';
import { MapsComponent } from './maps/maps.component';
import { MapstestComponent } from './mapstest/mapstest.component';
import {DecimalMask} from "./providers//decimal-mask.directive";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { SOAPClient } from '../soapclient.js';

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        DialogComponent,
        DatepickerComponent,
        ImageResizerListComponent,
        CustomerDetailsComponent,
        panelComponent,
        ShopComponent,
        CommonNavbarComponent,
        ProductDetailsComponent,
        FilterComponent,
        FooterComponent,
        DecimalMask,
        Carousel, Slide, DashboardComponent,KeysPipe, SearchProductsComponent, 
         CategoryproductComponent, TopsellerComponent, SearchlistComponent, CheckoutComponent, CustomFilterPipe, NoInternetComponent, ProductItemComponent, MobileResponsiveComponent, ErrorMessageComponent, CartListComponent, LoaderComponent, OrdersComponent, OrderlistComponent,
        //    OrderdescriptionComponent, 
        InvoiceStatusPipe,
        InvoiceSearchPipe,
          OrderstatusPipe,
          OrderStatusPipe,
          NoCommaPipe,
        InvoicelistComponent,
        InvoicedescriptionComponent,
        CollectpaymentComponent,
        CartdescriptionComponent,
        SupervisorLoginComponent,
        MapsComponent,
        MapstestComponent, 
        //   OnlyNumber
    ],
    imports: [
        BrowserModule,
        NoopAnimationsModule,
        ExpandableListModule,
        AppRoutingModule,
        FormsModule,
        SignaturePadModule,
        TooltipModule,
        CurrencyMaskModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        HttpModule,NgxPaginationModule,
        ReactiveFormsModule, AsyncLocalStorageModule,Ng2OrderModule,
        TreeModule,ToasterModule,Ng2SearchPipeModule, MomentModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyBKoXJHuc7spcA4BdLzlc1kcCCfxdg8D20',
            libraries: ["places"]
          })
    ],
    providers: [
        CustomStorage, ViewStateService,SharedServiceService, CookieService, ConstantService, CustomerDetailsService, ProductDetailsService,
        LanguageService, CustomCookieService, ProductService,ToasterService,ToastService,GoogleMapsAPIWrapper,
        // OnlyNumber,
        SoapService,
        SOAPClient,
        GoogleMapsAPIWrapper,
        RestApiServices,ProductSearchService,Entity, AuthService, AuthGuard, CartitemsService],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts